// sidebarMenu.js
const sidebarMenu = [
  {
    href: "/",
    label: "Overview",
    icon: "fas fa-fw fa-columns",
    roles: ["admin", "user"], // visible to both
  },
  {
    href: "/tickets",
    label: "Tickets",
    icon: "far fa-fw fa-life-ring",
    roles: ["admin", "user"], // only visible to admin
  },

  {
    label: "Settings",
    icon: "fas fa-fw fa-sticky-note",
    roles: ["admin"],
    children: [
      {
        href: "/users",
        label: "Users",
        icon: "fas fa-fw fa-list-alt fa-sm",
      },
      {
        href: "/departments",
        label: "Departments",
        icon: "fas fa-fw fa-list-alt fa-sm",
      },

      {
        label: "Categories",
        href: "/categories",
        icon: "fas fa-fw fa-map-marked-alt fa-sm",
      },
    ],
  },
];

export default sidebarMenu;
